<template>
    <div>
        <BaseBreadCrumb :items="departmentBreadcrumb" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { formatChildParentBreadCrumb } from '../../../../../utilities/json-formatter';
import { departmentStore } from '../../../../../store/global-stores';

const props = defineProps({
    deptId: {
        type: Number,
    },
});

const departmentBreadcrumb = ref([]);

onMounted(() => {
    loadDepartmentDetails();
});

const loadDepartmentDetails = async () => {
    if (props.deptId) {
        const deptDetails = await departmentStore.fetchDepartmentDetails(props.deptId);
        departmentBreadcrumb.value = formatChildParentBreadCrumb(deptDetails, 30);
    }
};
</script>
